/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import BaseService from '../../../services/BaseService';
import { ChartCard } from '../RelatorioDigitacao/chartShared';
import ChartFocusDialog from '../RelatorioDigitacao/ChartFocusDialog';
import MaterialByMalhaChart from './MaterialByMalhaChart';
import MaterialChart from './MaterialChart';

const FOCUS_HEIGHT = 520;

const ChartsRow = ({ apiFilterBase, refreshKey, onMalhaSegmentSelect }) => {
  const [materialItems, setMaterialItems] = useState([]);
  const [materialLoading, setMaterialLoading] = useState(false);
  const [malhaItems, setMalhaItems] = useState([]);
  const [malhaMaterialColumns, setMalhaMaterialColumns] = useState([]);
  const [malhaLoading, setMalhaLoading] = useState(false);
  const [focusMaterial, setFocusMaterial] = useState(false);
  const [focusMalha, setFocusMalha] = useState(false);

  const fetchMaterial = useCallback(async () => {
    setMaterialLoading(true);
    try {
      const response = await BaseService.post({
        url: 'reports/uso-mutuo/charts/by-material',
        data: apiFilterBase,
      });
      setMaterialItems(response?.data?.items || []);
    } catch {
      setMaterialItems([]);
    } finally {
      setMaterialLoading(false);
    }
  }, [apiFilterBase, refreshKey]);

  const fetchMalhaMaterial = useCallback(async () => {
    setMalhaLoading(true);
    try {
      const response = await BaseService.post({
        url: 'reports/uso-mutuo/charts/by-malha-material',
        data: apiFilterBase,
      });
      setMalhaItems(response?.data?.items || []);
      setMalhaMaterialColumns(response?.data?.materialColumns || []);
    } catch {
      setMalhaItems([]);
      setMalhaMaterialColumns([]);
    } finally {
      setMalhaLoading(false);
    }
  }, [apiFilterBase, refreshKey]);

  useEffect(() => {
    fetchMaterial();
  }, [fetchMaterial]);

  useEffect(() => {
    fetchMalhaMaterial();
  }, [fetchMalhaMaterial]);

  const materialTitle = 'Peso por material';
  const malhaTitle = 'Material por malha';

  return (
    <>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, lg: 6 }}>
          <ChartCard title={materialTitle} onExpand={() => setFocusMaterial(true)} contentSx={{ pl: 1, pr: 2 }}>
            <MaterialChart items={materialItems} loading={materialLoading} />
          </ChartCard>
        </Grid>
        <Grid size={{ xs: 12, lg: 6 }}>
          <ChartCard title={malhaTitle} onExpand={() => setFocusMalha(true)} contentSx={{ pl: 1, pr: 2 }}>
            <MaterialByMalhaChart
              items={malhaItems}
              materialColumns={malhaMaterialColumns}
              loading={malhaLoading}
              onSegmentSelect={onMalhaSegmentSelect}
            />
          </ChartCard>
        </Grid>
      </Grid>

      <ChartFocusDialog open={focusMaterial} title={materialTitle} onClose={() => setFocusMaterial(false)}>
        <MaterialChart items={materialItems} loading={materialLoading} height={FOCUS_HEIGHT} />
      </ChartFocusDialog>

      <ChartFocusDialog open={focusMalha} title={malhaTitle} onClose={() => setFocusMalha(false)}>
        <MaterialByMalhaChart
          items={malhaItems}
          materialColumns={malhaMaterialColumns}
          loading={malhaLoading}
          height={FOCUS_HEIGHT}
          onSegmentSelect={onMalhaSegmentSelect}
        />
      </ChartFocusDialog>
    </>
  );
};

ChartsRow.propTypes = {
  apiFilterBase: PropTypes.object.isRequired,
  refreshKey: PropTypes.bool,
  onMalhaSegmentSelect: PropTypes.func,
};

ChartsRow.defaultProps = {
  refreshKey: false,
  onMalhaSegmentSelect: null,
};

export default ChartsRow;
